module.exports = ".tilebar-panel {\n  border: solid 2px #555;\n  overflow: auto;\n}\n.tilebar-panel > div {\n  border: dotted 1px #ccc;\n  display: inline-block;\n  margin: 5px;\n}\n.tilebar-panel > div > img {\n  width: 30px;\n  height: 30px;\n}\n.tilebar-panel .separator {\n  display: block;\n  height: 10px;\n  border: none;\n}\n.tilebar-panel .selected {\n  border: solid 2px blue;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/tilesbar/tilesbar.component.less
// module id = ./src/app/layout/tilesbar/tilesbar.component.less
// module chunks = main